module.exports = __webpack_public_path__ + "img/case_bottom_007.466651e1.png";